export type NotificationsKind = 'notifications' | 'messages';

export enum NotificationType {
  NOTIFICATION = 'NOTIFICATION',
  ALERT = 'ALERT',
}

export interface Notifications {
  id: number;
  subject: string;
  body: string;
  created: string;
  type: NotificationType;
  document_id: number;
  requires_review: boolean;
  opened: boolean;
  facility?: string;
}

export interface NotificationsState {
  readonly notifications: readonly Notifications[];
  readonly loading: boolean;
}
